module.exports = __webpack_public_path__ + "basque-country.svg?ba4557345743d3941f477d8def8a08a8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/basque-country.svg
// module id = 106
// module chunks = 10